/**
 * MV2-1836: endereço que a estação recebe ao escolher o grupo. Copia os campos
 * do endereço do grupo, mas não o addressPk dele: estação e grupo passavam a
 * dividir a mesma linha no banco e excluir a estação apagava o endereço do
 * grupo. Mantém o addressPk da própria estação, a não ser que seja o do grupo.
 */
export const copyGroupAddress = (groupAddress, stationAddress) => {
  const { addressPk: groupAddressPk, ...fields } = groupAddress;
  const ownAddressPk = stationAddress?.addressPk ?? null;
  return {
    ...fields,
    addressPk: ownAddressPk !== groupAddressPk ? ownAddressPk : null,
  };
};
